import React, { useState } from 'react'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { useForm, useFieldArray } from 'react-hook-form'
import useToastContext from 'hooks/useToastContext'
import OInputField from 'components/reusable/OInputField'
import { useTranslation } from 'react-i18next'
import { AiFillDelete } from 'react-icons/ai'
import ErrorMessage from 'components/ErrorMessage'
import helpers from 'utils/helpers'
import { numericInputPattern, preventMaxInput } from 'utils/validations'

const SalaryEdit = ({ allSubscription, currentItem, handleEdit }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const [isLoading, setIsLoading] = useState(false)
  const {
    register,
    handleSubmit,
    getValues,
    setError,
    control,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {
      allowance: currentItem?.allowance,
      deduction: currentItem?.deduction
    }
  })

  const {
    fields: allowanceFields,
    remove: allowanceRemove,
    append: allowanceAppend
  } = useFieldArray({ control, name: 'allowance' })

  const {
    fields: deductionFields,
    remove: deductionRemove,
    append: deductionAppend
  } = useFieldArray({ control, name: 'deduction' })

  const onSubmit = async data => {
    try {
      setIsLoading(true)
      const payload = {
        allowance: data?.allowance,
        deduction: data?.deduction
      }
      var path = apiPath.updateSalary + '/' + currentItem._id
      const result = await apiPut(path, payload)
      if (result.data.success) {
        allSubscription()
        handleEdit(false)
        notification.success(result?.data.message)
      } else {
        notification.error(result?.data.message)
      }
    } catch (error) {
      console.log('error in get all users list==>>>>', error)
      notification.error(error.message)
    }
    setIsLoading(false)
  }

  const renderButtonOrSpinner = () => {
    return helpers.ternaryCondition(isLoading, renderSpinner(), renderButton())
  }

  const renderSpinner = () => (
    <div className='spinner-container bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 ease-linear transition-all duration-150'>
      <div className='loading-spinner'></div>
    </div>
  )

  const renderButton = () => (
    <button
      className={`bg-LightBlue cursor-pointer text-sm px-8 py-2.5 rounded shadow hover:shadow-lg text-white active:bg-emerald-600 font-normal outline-none focus:outline-none mr-1 ease-linear transition-all duration-150`}
      onClick={handleSubmit(onSubmit)}
      type='submit'
    >
      {t('O_SAVE')}
    </button>
  )
  return (
    <>
      <div className='justify-center flex items-center overflow-x-hidden overflow-y-auto focus:outline-none fixed inset-0 z-50 outline-none '>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>Edit Salary</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => handleEdit(false)}
                  title='Close'
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto max-h-[500px] overflow-y-auto'>
                <div className='grid sm:grid-cols-2'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0 w-full group'>
                      {allowanceFields.map((item, index) => {
                        const fieldName = `allowance[${index}]`
                        return (
                          <>
                            {' '}
                            <div className='flex  items-center'>
                              <OInputField
                                wrapperClassName='relative z-0 w-full group my-2'
                                inputLabel={
                                  <>
                                    {t('ALLOWANCE')} ($)
                                    <span className='text-red-500'>*</span>
                                  </>
                                }
                                type='text'
                                name={`${fieldName}.allowanceChild`}
                                id={`${fieldName}.allowanceChild`}
                                onInput={e => preventMaxInput(e, 10)}
                                maxLength={10}
                                onKeyDown={event => numericInputPattern(event)}
                                register={register(
                                  `${fieldName}.allowanceChild`,
                                  {
                                    required: {
                                      value: true,
                                      message: 'Please enter allowance.'
                                    },
                                    maxLength: {
                                      value: 10,
                                      message: 'Maximum limit is 10 characters.'
                                    },
                                    pattern: {
                                      value: true,
                                      message: 'Only digits are allowed.'
                                    },
                                    validate: val => {
                                      const { deduction, allowance } =
                                        getValues()
                                      const totalDeduction = deduction
                                        .map(
                                          itemDeduction =>
                                            +itemDeduction?.deductionChild || 0
                                        )
                                        .reduce((a, b) => a + b, 0)
                                      const totalAllowance = allowance
                                        .map(
                                          itemAllowance =>
                                            +itemAllowance?.allowanceChild || 0
                                        )
                                        .reduce((a, b) => a + b, 0)
                                      if (
                                        Number(totalDeduction) <
                                          Number(totalAllowance) &&
                                        totalDeduction !== 0
                                      ) {
                                        setError(
                                          `deduction[${
                                            deduction.length - 1
                                          }].deductionChild`,
                                          {
                                            type: 'manual',
                                            message: ''
                                          }
                                        )
                                      }
                                    }
                                  }
                                )}
                              />
                              <div className='ps-2'>
                                {index !== 0 ? (
                                  <>
                                    <button
                                      type='button'
                                      onClick={() => {
                                        allowanceRemove(index)
                                      }}
                                    >
                                      <AiFillDelete className='w-5 h-5 text-red-600' />
                                    </button>
                                  </>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                            <ErrorMessage
                              message={
                                errors?.allowance?.[index]?.allowanceChild
                                  ?.message
                              }
                            />
                          </>
                        )
                      })}
                      <button
                        className='bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                        type='button'
                        onClick={() => {
                          allowanceAppend({ allowanceChild: '' })
                        }}
                      >
                        {t('O_ADD')}
                      </button>
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    {deductionFields.map((item, index) => {
                      const fieldName = `deduction[${index}]`
                      return (
                        <>
                          <div className='flex  items-center'>
                            <OInputField
                              wrapperClassName='relative z-0 w-full group my-2'
                              inputLabel={
                                <>
                                  {t('DEDUCTION')} ($)
                                  <span className='text-red-500'>*</span>
                                </>
                              }
                              type='text'
                              name={`${fieldName}.deductionChild`}
                              id={`${fieldName}.deductionChild`}
                              onInput={e => preventMaxInput(e, 10)}
                              maxLength={10}
                              onKeyDown={event => numericInputPattern(event)}
                              register={register(
                                `${fieldName}.deductionChild`,
                                {
                                  required: {
                                    value: true,
                                    message: 'Please enter deduction.'
                                  },
                                  maxLength: {
                                    value: 10,
                                    message: 'Maximum limit is 10 characters.'
                                  },
                                  pattern: {
                                    value: true,
                                    message: 'Only digits are allowed.'
                                  },
                                  validate: val => {
                                    const { allowance, deduction } = getValues()
                                    const totalDeduction = deduction
                                      .map(
                                        itemsDeduction =>
                                          +itemsDeduction?.deductionChild || 0
                                      )
                                      .reduce((a, b) => a + b, 0)
                                    const totalAllowance = allowance
                                      .map(
                                        itemsAllowance =>
                                          +itemsAllowance?.allowanceChild || 0
                                      )
                                      .reduce((a, b) => a + b, 0)
                                    if (
                                      Number(totalAllowance) <
                                      Number(totalDeduction)
                                    ) {
                                      return 'Deduction must be less than allowance.'
                                    }
                                  }
                                }
                              )}
                            />
                            <div className='ps-2'>
                              {' '}
                              {index !== 0 ? (
                                <>
                                  <button
                                    type='button'
                                    onClick={() => {
                                      deductionRemove(index)
                                    }}
                                  >
                                    <AiFillDelete className='w-5 h-5 text-red-600' />
                                  </button>
                                </>
                              ) : (
                                ''
                              )}
                            </div>
                          </div>
                          <ErrorMessage
                            message={
                              errors?.deduction?.[index]?.deductionChild
                                ?.message
                            }
                          />
                        </>
                      )
                    })}
                    <button
                      className='bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                      type='button'
                      onClick={() => {
                        deductionAppend({ deductionChild: '' })
                      }}
                    >
                      {t('O_ADD')}
                    </button>
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => handleEdit(false)}
                >
                  {t('O_BACK')}
                </button>
                {renderButtonOrSpinner()}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default SalaryEdit
